import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}><g fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 14V0M0 7h14" /></g></svg>);